import request from '@/utils/request'

// 题目列表查询
export function getQuestionList(params) {
    return request({
        url: '/api/admin/question/list',
        method: 'get',
        params
    })
}

// 新增题目
export function addQuestion(data) {
    return request({
        url: '/api/admin/question/add',
        method: 'post',
        data
    })
}

// 编辑题目
export function updateQuestion(data) {
    return request({
        url: '/api/admin/question/update',
        method: 'put',
        data
    })
}

// 题目详情
export function getQuestionDetail(id) {
    return request({
        url: `/api/admin/question/detail/${id}`,
        method: 'get'
    })
}


// Word批量导入题目
export function importQuestions(data) {
    return request({
        url: '/api/admin/question/import',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

// 图片题 Word 批量导入题目
export function importImageQuestions(data) {
    return request({
        url: '/api/admin/question/import-image',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

// 上传题目图片
export function uploadQuestionImage(data) {
    return request({
        url: '/api/admin/question/upload-image',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

// 启用/禁用题目
export function updateQuestionStatus(data) {
    return request({
        url: '/api/admin/question/status',
        method: 'put',
        data
    })


}